import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import PaypalRequests from "../modules/PaypalRequests/PaypalRequestsPage";

export function PaypalRequestsPage() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "paypal-requests-page-title",
    defaultMessage: "Paypal requests"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <PaypalRequests/>;
}
